import { parse } from "date-fns";

export const formatDateToLocal = (utcDate?: string, withTime = true) => {
  if (!utcDate) return "";
  // If the backend returns a date without the .000Z, we add it. We know it's stored as UTC in DB.
  if (!utcDate.endsWith(".000Z")) {
    utcDate = `${utcDate}.000Z`;
  }
  try {
    const date = new Date(utcDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    if (withTime) {
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    }

    return `${day}-${month}-${year}`;
  } catch {
    return utcDate;
  }
};

export const formatDateToLocal__Date = (utcDate?: string) => {
  if (!utcDate) return "";
  // If the backend returns a date without the .000Z, we add it. We know it's stored as UTC in DB.
  if (!utcDate.endsWith(".000Z")) {
    utcDate = `${utcDate}.000Z`;
  }
  try {
    const date = new Date(utcDate);
    return date;
  } catch {
    return "";
  }
};

export const formatToUTC = (dateString: string | undefined) => {
  if (!dateString) return "";
  // 2025-02-18T23:00:00
  try {
    const localDate = parse(dateString, "dd-MM-yyyy HH:mm", new Date());
    return localDate.toISOString();
  } catch (e) {}

  try {
    const localDate = parse(dateString, "dd-MM-yyyy", new Date());
    return localDate.toISOString();
  } catch (e) {}

  return dateString;
};

export const convertTimeToUtc = (timeString: string) => {
  const [hours, minutes] = timeString.split(":").map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  const splitted = date.toISOString().split("T")[1].split(":");
  return `${splitted[0]}:${splitted[1]}`;
};
